import { defineFcm } from '../shared/factory';

export const FCM_DECISION_MAKER_CLASSIFIER_CITY_COUNCIL = defineFcm('decision_maker_classifier_city_council')
	.asBoolean()
	.withDefault(false)
	.toConfig({
		owner: 'squad-capybara',
		scope: 'llm-service',
		context: 'Decision maker classification — city council',
		description: 'Enables the LLM-based city council classifier in the petition decision maker classifier service.',
		import: false,
	});
